import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { registrationRoutesConfig } from './auto-registration/registration-config';
import { AutoRegistrationComponent } from './auto-registration/auto-registration.component';
import { SignUpComponent } from './auto-registration/sign-up/sign-up.component';
import { RegistrationStepsComponent } from './auto-registration/registration-steps/registration-steps.component';
import { SmartSuggestionsComponent } from './auto-registration/smart-suggestions/smart-suggestions.component';
import { SignUp2Component } from './auto-registration/sign-up2/sign-up2.component';
import { RegistrationSteps2Component } from './auto-registration/registration-steps2/registration-steps2.component';

const autoRegistrationRoutes: Routes = [
  {
    path: '',
    component: AutoRegistrationComponent,
    children: [
      { path: '', redirectTo: registrationRoutesConfig.SIGNUP, pathMatch: 'full' },
      {
        path: registrationRoutesConfig.SIGNUP,
        // component: SignUpComponent,
        component: SignUp2Component,
      },
      {
        path: registrationRoutesConfig.RESET_PASSWORD,
        // component: SignUpComponent,
        component: SignUp2Component,
      },
      {
        path: registrationRoutesConfig.CHOOSE_BUSINESS,
        // component: RegistrationStepsComponent,
        component: RegistrationSteps2Component,
      },
      {
        path: registrationRoutesConfig.VERIFY,
        // component: SignUpComponent,
        component: SignUp2Component,
      },
      {
        path: registrationRoutesConfig.SMART_SUGGESTIONS,
        component: SmartSuggestionsComponent,
      },
    ],
  },
];

const routes: Routes = [
  ...autoRegistrationRoutes,
  {
    path: '**',
    redirectTo: '',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule],
})
export class AppRoutingModule {}
